import React from 'react';
import {
  MVPBanner,
  // MVPChoose,
  MVPQuestions,
  MVPReady,
  MVPSuccess,
  MVPTerms,
  MVPWhat,
  MVPWorks
} from '../../sections';

const MVPPage = () => {
  return (
    <>
      <MVPBanner />
      {/* <MVPChoose /> */}
      <MVPWorks />
      <MVPWhat />
      <MVPSuccess />
      <MVPQuestions />
      <MVPReady />
      <MVPTerms />
    </>
  );
};

export default MVPPage;
